import { extendTheme } from "@chakra-ui/react";

const theme = extendTheme({
  styles: {
    global: {
      "html, body": {
        bg: "white",
        color: "black",
        
      },
    },
  },
});


export default theme;
